export default __webpack_public_path__ + "media/images/67-79f4fc7844f3ed21c96f37cb3500a7d0.jpg";